import Button from '../Button/Button'
import DynamicFaIcon from '../DynamicFaIcon/DynamicFaIcon'

export interface ModalProps {
    // isOpen: boolean
    buttonText?: string | React.ReactNode
    cancelButtonText?: string | React.ReactNode
    onRequestClose?(): void
    onConfirm?(): void
    children?: React.ReactNode
    ariaLabel?: string
    disableConfirm?: boolean
}

const Modal: React.FunctionComponent<ModalProps> = ({
    buttonText,
    cancelButtonText,
    onRequestClose,
    onConfirm,
    children,
    ariaLabel,
    disableConfirm
}) => {
    const handleConfirm = () => {
        onConfirm?.()
        onRequestClose?.()
    }

    return (
        <div
            className='fixed top-0 left-0 w-full h-full z-50 bg-black bg-opacity-30 text-center flex flex-col justify-center items-center'
            onClick={onRequestClose}
            aria-label={ariaLabel}
        >
            <div
                className='border rounded-lg bg-white relative w-full max-w-[500px] flex flex-col h-auto max-h-full'
                onClick={(e) => e.stopPropagation()}
            >
                <button className='absolute top-0 right-0 m-4' onClick={onRequestClose}>
                    <DynamicFaIcon iconName='times' />
                </button>

                {children}

                <div className='w-full border-t px-4 py-3 flex space-x-2 justify-end items-center'>
                    {cancelButtonText && (
                        <Button onClick={onRequestClose} className='!bg-[--tb-primary-cc] !text-[--tb-primary] border'>
                            {cancelButtonText}
                        </Button>
                    )}
                    <Button onClick={handleConfirm} disabled={disableConfirm}>
                        {buttonText}
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default Modal
